export default "__VITE_ASSET__DSgeVonY__"